var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 13,
    viewBox: "0 0 27 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85339 11.5669L1.41873 5.06687L0 6.5L6.43467 13L7.85339 11.5669Z",
    fill: "#8A8A8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85339 1.43313L1.41872 7.93313L0 6.5L6.43467 0L7.85339 1.43313Z",
    fill: "#8A8A8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 7.51336V5.48661L1.92028 5.48661L1.92028 7.51336L27 7.51336Z",
    fill: "#8A8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.2b15bd5d254efa8e7beded62bc9e6aa6.svg";
export { ForwardRef as ReactComponent };